import React from "react";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Pagination,
} from "@mui/material";
import s from "./Pagination.module.css";
import { useTranslation } from "react-i18next";

const Pager = ({
  pageSize,
  setPageSize,
  page,
  setPage,
  totalPages,
  pageCustom,
  setPageCustom,
}) => {
  const { t } = useTranslation();
  const handlePaginate = (e, v) => {
    setPage(v);
  };

  return (
    <Grid
      container
      item
      xs={12}
      lg={8}
      md={10}
      className={s.pagination}
      sx={{ mt: "50px" }}
    >
      <Grid
        item
        xs={10}
        lg={2}
        md={10}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ml: "10px",
          mt: "10px",
        }}
      >
        <FormControl sx={{ width: "60%" }}>
          <InputLabel id="pagesize-select">{t("results")}</InputLabel>
          <Select
            size="small"
            value={pageSize}
            label="Resultados"
            onChange={(e) => {
              setPage(1);
              setPageSize(e.target.value);
            }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ml: "10px",
          mt: "10px",
        }}
        className={s.pager}
      >
        <Pagination
          siblingCount={0}
          count={totalPages}
          page={page}
          color={"primary"}
          showFirstButton
          showLastButton
          onChange={handlePaginate}
        />
      </Grid>
      <Grid
        item
        xs={10}
        lg={2}
        className={s.customPage}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ml: "10px",
          mt: "10px",
        }}
      >
        <TextField
          size="small"
          type={"number"}
          value={pageCustom}
          onChange={(e) => setPageCustom(e.target.value)}
          sx={{ width: "40%", mr: "5px" }}
        />
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            if (0 <= pageCustom && pageCustom <= totalPages) {
              setPage(pageCustom * 1);
            } else {
              setPageCustom(page);
            }
          }}
        >
          Ir
        </Button>
      </Grid>
    </Grid>
  );
};

export default Pager;
